import { useMediaQuery, useTheme } from '@mui/material';

export const useLaptop = () => {
  const theme = useTheme();
  const isOverLaptop = useMediaQuery(theme.breakpoints.up('laptop'));

  return { isOverLaptop };
};
